import React, { useContext } from 'react';
import Wrapper from './MenuItem.styled';
import MenuContext from '../Menu.Context';

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  id: string;
}

function MenuItem({
  className,
  children,
  id,
  ...aProps
}: Props): React.ReactElement {
  const context = useContext(MenuContext);
  const { activeId, changeActiveId } = context;

  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!aProps.href) {
      e.preventDefault();
      if (changeActiveId) changeActiveId(id);
    }
  };

  return (
    <Wrapper
      id={id}
      className={`${className} ${activeId === id ? 'active' : ''}`}
      {...aProps}
      onClick={onClick}
    >
      {children}
    </Wrapper>
  );
}

export default MenuItem;
